/**
 * What a plan lets a workspace do. Interim rule until the billing module defines entitlements:
 * building with Weavex AI and starting from a template are paid features (Figma "Upgrade required").
 */
import type { Plan } from "./types";

export function canBuildWithAi(plan: Plan | undefined): boolean {
  return Boolean(plan && plan.monthly_price_cents > 0);
}

/** Growth Intelligence is part of the plan (PRD D-07: Growth and Pro). */
export function canUseGrowth(plan: Plan | undefined): boolean {
  return Boolean(plan?.growth_intelligence);
}

/** Competitor websites the plan lets Growth Intelligence watch (PRD D-05). */
export function competitorLimit(plan: Plan | undefined): number {
  return plan?.max_competitors ?? 0;
}
